@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}

<form [formGroup]="srchEngagements">
  <div class="topsrchnav">
    <div class="ui-g form-group">
      <div class="ui-g-0 ui-md-4"></div>
      <div class="ui-g-12 ui-md-4">
        <div class="ui-inputgroup">
          <input
            class="input-search"
            type="text"
            pInputText
            #txtSrch
            id="txtEngagementSrch"
            formControlName="txtEngagementSrch"
            placeholder="Search by PartnerID"
            (keypress)="numericOnly($event)"
            maxlength="8" />
          <button
            class="button-search"
            pButton
            type="button"
            (click)="searchEngagements()"
            [disabled]="disableSrchButton"
            icon="ui-icon-search">
            Search
          </button>
        </div>
      </div>
      <div class="ui-g-0 ui-md-4">
        <div class="iscnav">
          <label for="isC3CustomerCheckbox">SMC Engagement?</label>
          <p-checkbox
            id="isC3CustomerCheckbox"
            class="c3-checkbox"
            name="isC3CustomerBool"
            [(ngModel)]="isC3CustomerBool"
            formControlName="isC3CustomerBool"
            (onChange)="isC3EventChange()"
            [binary]="true"></p-checkbox>
        </div>
      </div>
    </div>
  </div>
</form>

@for (message of msgs; track message) {
  <p-message [life]="3000" [text]="message.detail"></p-message>
}

@if (showPartnerInfo) {
  <div id="tblDivPartner">
    <div class="ui-g card p-1">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div>
          <div class="ui-g-6 ui-md-6 ui-lg-6 p-info">Partner Information</div>
          <div class="ui-g-6 ui-md-6 ui-lg-6 p-info">
            <div class="float-right" aria-label="PartnerOne ID">
              {{ 'PartnerOne ID' + ':' + partnerOneId }}
            </div>
          </div>
        </div>
        <div class="partnerinfo">
          <table>
            <tr>
              <td>
                Organization Name<br /><span class="clrblue">{{
                  partnerOrgName
                }}</span>
              </td>
              <td>
                SMCpartner<br /><span
                  [ngClass]="isC3partner === true ? 'clrgreen' : 'clrred'"
                  >{{ isC3partner }}</span
                >
              </td>
              <td>
                SMCSecurity Partner<br /><span
                  [ngClass]="
                    isC3SecurityPartner === true ? 'clrgreen' : 'clrred'
                  "
                  >{{ isC3SecurityPartner }}</span
                >
              </td>
              <td>
                SMCTeams Partner<br /><span
                  [ngClass]="isC3TeamsPartner === true ? 'clrgreen' : 'clrred'"
                  >{{ isC3TeamsPartner }}</span
                >
              </td>
              <td>
                Opt-out Partner<br /><span
                  [ngClass]="isOptOutPartner ? 'clrgreen' : 'clrred'"
                  >{{ isOptOutPartner }}</span
                >
              </td>
              <td>
                CoSellReady<br /><span
                  [ngClass]="isCoSellReady === true ? 'clrgreen' : 'clrred'"
                  >{{ isCoSellReady }}</span
                >
              </td>
              <td>
                Communication<br /><span
                  [ngClass]="isCommunication === true ? 'clrgreen' : 'clrred'"
                  >{{ isCommunication }}</span
                >
              </td>
              <td>
                Fttready<br /><span
                  [ngClass]="isFttready === true ? 'clrgreen' : 'clrred'"
                  >{{ isFttready }}</span
                >
              </td>
              <td>
                Security<br /><span
                  [ngClass]="isSecurity === true ? 'clrgreen' : 'clrred'"
                  >{{ isSecurity }}</span
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
}

@if (showPartnerInfo) {
  <div id="tblDivPartner">
    <div class="ui-g">
      <div class="readonlytbox pb-3" [formGroup]="formPartnerCompliance">
        <div
          class="ui-g-4 ui-sm-6 ui-md-8"
          style="height: 100%; padding-left: 0px">
          <div class="card information-card mb-0" style="height: 100%">
            <div class="card-body pt-2">
              <div class="ui-g">
                <div class="ui-lg-12 ui-md-12 card-title">
                  <div class="ui-g-12">
                    <div class="ui-g-6 ui-md-6 ui-lg-6">
                      <div
                        class="tile-head font-bold"
                        aria-label="Partner Compliance Information">
                        Partner Compliance Information
                      </div>
                    </div>
                    <div class="ui-g-6 ui-md-6 ui-lg-6 edit-btn">
                      <div class="ui-g-2 compliance-edit-btn float-right">
                        <span
                          class="fa fa-pencil ico cpointer fl-rt pen-for-white-glove"
                          pTooltip="Edit Partner Compliance"
                          (click)="editPartnerComplianceInfo()"
                          (keydown.enter)="editPartnerComplianceInfo()"
                          tabindex="0"
                          tooltipPosition="bottom"></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="rtnav ui-g-12">
                  <div class="ui-g-8 msgbox-6"></div>
                  @if (loadingCompliance) {
                    <div class="loading-indicator">
                      <p-progressSpinner></p-progressSpinner>
                    </div>
                  }
                  @if (!isEditPartnerCompliance) {
                    <div class="ui-g-4"></div>
                  }
                  @if (isEditPartnerCompliance) {
                    <div class="ui-g-4 compliance-btn-container">
                      @if (!isBlockReasonSelected) {
                        <button
                          type="submit"
                          pButton
                          disabled
                          class="flat btnmr fl-rt">
                          Save
                        </button>
                      }
                      @if (isBlockReasonSelected) {
                        <button
                          type="submit"
                          pButton
                          [disabled]="isSaveComplianceDisabled"
                          (click)="onSavePartnerCompliance()"
                          class="flat btnmr fl-rt">
                          Save
                        </button>
                      }
                      <button
                        type="button"
                        pButton
                        (click)="onCancelEditPartnerCompliance()"
                        class="ui-button-secondary flat fl-rt">
                        Cancel
                      </button>
                    </div>
                  }
                </div>

                <div>
                  <div class="new">
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2 font-bold">
                        Program Name
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4 font-bold">
                        Blocked Status
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4 font-bold">
                        Blocked Reason
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2">MCAP</div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="blockStatus"
                          [readonly]="!isEditPartnerCompliance"
                          (onChange)="onMcapBlockStatusChange($event)"
                          optionLabel="statusName"
                          [class.readonlydd]="isEditPartnerCompliance === false"
                          formControlName="isMcapBlocked">
                        </p-select>
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="mcapBlockReasons"
                          [readonly]="
                            !isMcapBlocked || !isEditPartnerCompliance
                          "
                          (onChange)="onMcapBlockReasonChange($event)"
                          [class.readonlydd]="
                            isMcapBlocked === false ||
                            isEditPartnerCompliance === false
                          "
                          placeholder="Select Reason"
                          optionLabel="reasonDescription"
                          formControlName="mcapBlockReason"></p-select>
                        <div class="ui-g-12 ui-md-4 ui-lg-12 compliance-error">
                          {{
                            checkForComplianceErrorMessage(
                              isMcapBlocked,
                              formPartnerCompliance.controls['mcapBlockReason']
                                .value.reasonDescription
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2">Operator</div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="blockStatus"
                          [readonly]="!isEditPartnerCompliance"
                          (onChange)="onOperatorBlockStatusChange($event)"
                          [class.readonlydd]="isEditPartnerCompliance === false"
                          optionLabel="statusName"
                          formControlName="isOperatorBlocked">
                        </p-select>
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="operatorBlockReasons"
                          [readonly]="
                            !isOperatorBlocked || !isEditPartnerCompliance
                          "
                          (onChange)="onOperatorBlockReasonChange($event)"
                          [class.readonlydd]="
                            isOperatorBlocked === false ||
                            isEditPartnerCompliance === false
                          "
                          placeholder="Select Reason"
                          optionLabel="reasonDescription"
                          formControlName="operatorBlockReason"></p-select>

                        <div class="ui-g-12 ui-md-4 ui-lg-12 compliance-error">
                          {{
                            checkForComplianceErrorMessage(
                              isOperatorBlocked,
                              formPartnerCompliance.controls[
                                'operatorBlockReason'
                              ].value.reasonDescription
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2">Mssp</div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="blockStatus"
                          [readonly]="!isEditPartnerCompliance"
                          (onChange)="onMsspBlockStatusChange($event)"
                          [class.readonlydd]="isEditPartnerCompliance === false"
                          optionLabel="statusName"
                          formControlName="isMsspBlocked">
                        </p-select>
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="msspBlockReasons"
                          [readonly]="
                            !isMsspBlocked || !isEditPartnerCompliance
                          "
                          (onChange)="onMsspBlockReasonChange($event)"
                          [class.readonlydd]="
                            isMsspBlocked === false ||
                            isEditPartnerCompliance === false
                          "
                          placeholder="Select Reason"
                          optionLabel="reasonDescription"
                          formControlName="msspBlockReason"></p-select>
                        <div class="ui-g-12 ui-md-4 ui-lg-12 compliance-error">
                          {{
                            checkForComplianceErrorMessage(
                              isMsspBlocked,
                              formPartnerCompliance.controls['msspBlockReason']
                                .value.reasonDescription
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2">Events</div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="blockStatus"
                          [readonly]="!isEditPartnerCompliance"
                          (onChange)="onEventsBlockStatusChange($event)"
                          [class.readonlydd]="isEditPartnerCompliance === false"
                          optionLabel="statusName"
                          formControlName="isEventsBlocked">
                        </p-select>
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-4">
                        <p-select
                          [options]="eventsBlockReasons"
                          [readonly]="
                            !isEventsBlocked || !isEditPartnerCompliance
                          "
                          (onChange)="onEventsBlockReasonChange($event)"
                          [class.readonlydd]="
                            isEventsBlocked === false ||
                            isEditPartnerCompliance === false
                          "
                          placeholder="Select Reason"
                          optionLabel="reasonDescription"
                          formControlName="eventsBlockReason"></p-select>
                        <div class="ui-g-12 ui-md-4 ui-lg-12 compliance-error">
                          {{
                            checkForComplianceErrorMessage(
                              isEventsBlocked,
                              formPartnerCompliance.controls[
                                'eventsBlockReason'
                              ].value.reasonDescription
                            )
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="ui-g-4 ui-sm-6 ui-md-4"
          style="height: 100%; padding-right: 0px">
          <div class="card information-card mb-0" style="height: 100%">
            <div class="card-body pt-2">
              <div class="ui-g-12">
                <div class="card-title">
                  <div class="ui-g-12">
                    <div class="ui-g-12 ui-md-8 ui-lg-8 workshop-label">
                      <div
                        class="tile-head font-bold"
                        aria-label="Workshop Allocation">
                        Workshop Allocation
                      </div>
                    </div>
                  </div>
                </div>

                <div class="new">
                  <div class="ui-g-12 mt-2">
                    <div class="ui-g-12 ui-md-12 ui-lg-12">
                      <p-select
                        [options]="eventTypes"
                        name="selectedEventType"
                        (onChange)="oneventEventTypeChange($event)"
                        [(ngModel)]="selectedEventType"
                        optionLabel="eventName"
                        formControlName="selectedEventType"></p-select>
                    </div>
                  </div>
                  <div class="ui-g-12 mt-2">
                    <div class="ui-g-12 ui-md-12 ui-lg-6 dropdown">
                      <p-select
                        [options]="fiscalYearData"
                        name="selectedFiscalYear"
                        (onChange)="oneventFiscalYearChange($event)"
                        [(ngModel)]="selectedFiscalYear"
                        optionLabel="fiscalYearDisplayName"
                        formControlName="selectedFiscalYear"></p-select>
                    </div>
                    <div class="ui-g-12 ui-md-12 ui-lg-6 dropdown">
                      <p-select
                        [options]="qaurterDropdown"
                        name="selectedQuarter"
                        (onChange)="oneventQuarterChange($event)"
                        [(ngModel)]="selectedQuarter"
                        optionLabel="quarterName"
                        formControlName="selectedQuarter"></p-select>
                    </div>
                  </div>
                  <div class="ui-g-12 mt-2">
                    <div class="ui-g-12 ui-md-6 ui-lg-6 dropdown">
                      @if (showPartnerOneAreas) {
                        <p-select
                          [options]="partnerOneAreas"
                          name="selectedArea"
                          placeholder="Select Area"
                          (onChange)="oneventPartnerOneAreaChange($event)"
                          [(ngModel)]="selectedArea"
                          optionLabel="area"
                          formControlName="selectedArea"></p-select>
                      }
                    </div>
                    <div class="ui-g-12 ui-md-6 ui-lg-6 dropdown">
                      @if (showPartnerOneCountries) {
                        <p-select
                          [options]="partnerOneCountriesOnArea"
                          name="selectedCountry"
                          placeholder="Select Country"
                          (onChange)="oneventPartnerOneCountryChange($event)"
                          [(ngModel)]="selectedCountry"
                          optionLabel="country"
                          formControlName="selectedCountry"></p-select>
                      }
                    </div>
                  </div>
                  @if (
                    !isAreaSelected ||
                    !isCountrySelected ||
                    allocationData.quarterlimit !== null
                  ) {
                    <div>
                      <div class="ui-g-12 mt-1">
                        <div class="ui-g-12 ui-md-6 ui-lg-6">
                          <div class="col-6">
                            <p class="ms-fontSize-m">Workshop limit</p>
                          </div>
                        </div>
                        <div class="ui-g-12 ui-md-6 ui-lg-6">
                          <div class="col-6">
                            <span>{{ allocationData.quarterlimit }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12 mt-1">
                        <div class="ui-g-12 ui-md-6 ui-lg-6">
                          <div class="col-6">
                            <p class="ms-fontSize-m">Completed workshops</p>
                          </div>
                        </div>
                        <div class="ui-g-12 ui-md-6 ui-lg-6">
                          <div class="col-6">
                            <span>{{ allocationData.eventsCount }}</span>
                          </div>
                        </div>
                      </div>
                      <div class="ui-g-12 mt-1">
                        <div class="ui-g-12 ui-md-6 ui-lg-6">
                          <div class="col-6">
                            <p class="ms-fontSize-m">Remaining workshops</p>
                          </div>
                        </div>
                        <div class="ui-g-12 ui-md-6 ui-lg-6">
                          <div class="col-6">
                            <span>{{
                              allocationData.eventsRemainingCount
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  @if (
                    allocationData.quarterlimit === null &&
                    isAreaSelected &&
                    isCountrySelected &&
                    !loading
                  ) {
                    <div class="row m-2">
                      <div class="ui-g-12 mt-5">
                        <p class="ms-fontSize-s info-color">
                          No workshop allocation has been assigned for this
                          PartnerOne ID, for selected Workshop, FY, Area and
                          Country.
                        </p>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showPartnerPaymentInfo) {
  <app-payment-information
    [partnerPaymentDetails]="partnerPaymentDetails"
    [searchedMpnId]="searchedMpnId"
    [fiscalYear]="this.fiscalYear"
    (onPayeeInfoUpdate)="
      refreshPartnerPaymentDetails($event)
    "></app-payment-information>
}

@if (showPartnerInfo && showConcierge) {
  <div id="tblDivPartner">
    <div class="ui-g card boxtb">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="partnerinfo">
          <div class="ui-g card-title">
            <div class="ui-g-8 white-glove-title pl-0">
              Concierge Information
            </div>
            <div class="ui-g-4 compliance-edit-btn">
              <span
                class="fa fa-pencil ico cpointer fl-rt pen-for-white-glove"
                pTooltip="Edit Partner Compliance"
                (click)="editConciergeInfo()"
                (keydown.enter)="editConciergeInfo()"
                tabindex="0"
                tooltipPosition="bottom"></span>
            </div>
          </div>
        </div>
      </div>
      <div class="readonlytbox pb-3" [formGroup]="formConcierge">
        <div class="ui-g-12 ui-md-12 ui-lg-12" style="height: 100%">
          <div class="card information-card mb-0" style="height: 100%">
            <div class="card-body pt-2">
              <div class="ui-g">
                <div>
                  <div class="new">
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2 font-bold">
                        Program Name
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5 font-bold">
                        Date Concierge engaged
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5 font-bold">
                        Concierge status
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2">Operator</div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5">
                        <p-datepicker
                          [maxDate]="dateTime"
                          hourFormat="12"
                          [readonlyInput]="!isEditConcierge"
                          [disabled]="!isEditConcierge"
                          [showOnFocus]="isEditConcierge"
                          [showIcon]="true"
                          [iconDisplay]="'input'"
                          (onSelect)="onConciergeChange()"
                          inputId="basic"
                          formControlName="conciergeDateOperator"
                          placeholder="Click to select date"></p-datepicker>
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5">
                        <p-select
                          [options]="conciergeStatuses"
                          formControlName="conciergeStatusOperator"
                          placeholder="Status"
                          optionLabel="name"
                          (onChange)="onConciergeStatusChange()"
                          [readonly]="!isEditConcierge"></p-select>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2">Mssp</div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5">
                        <p-datepicker
                          [maxDate]="dateTime"
                          hourFormat="12"
                          [showIcon]="true"
                          [iconDisplay]="'input'"
                          [readonlyInput]="!isEditConcierge"
                          [disabled]="!isEditConcierge"
                          [showOnFocus]="isEditConcierge"
                          (onSelect)="onConciergeChange()"
                          inputId="basic"
                          formControlName="conciergeDateMSSP"
                          placeholder="Click to select date"></p-datepicker>
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5">
                        <p-select
                          [options]="conciergeStatuses"
                          formControlName="conciergeStatusMSSP"
                          placeholder="Status"
                          optionLabel="name"
                          (onChange)="onConciergeStatusChange()"
                          [readonly]="!isEditConcierge"></p-select>
                      </div>
                    </div>
                    <div class="ui-g-12">
                      <div class="ui-g-12 ui-md-4 ui-lg-2">Events</div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5">
                        <p-datepicker
                          [maxDate]="dateTime"
                          hourFormat="12"
                          [showIcon]="true"
                          [iconDisplay]="'input'"
                          [readonlyInput]="!isEditConcierge"
                          [disabled]="!isEditConcierge"
                          [showOnFocus]="isEditConcierge"
                          (onSelect)="onConciergeChange()"
                          inputId="basic"
                          formControlName="conciergeDateEvents"
                          placeholder="Click to select date"></p-datepicker>
                      </div>
                      <div class="ui-g-12 ui-md-4 ui-lg-5">
                        <p-select
                          [options]="conciergeStatuses"
                          formControlName="conciergeStatusEvents"
                          placeholder="Status"
                          optionLabel="name"
                          (onChange)="onConciergeStatusChange()"
                          [readonly]="!isEditConcierge"></p-select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="rtnav ui-g-12">
                <div class="ui-g-8 msgbox-6"></div>
                @if (isEditConcierge) {
                  <div class="ui-g-4 compliance-btn-container">
                    <button
                      type="submit"
                      pButton
                      [disabled]="isDisableSaveConcierge"
                      (click)="saveConciergeInfo()"
                      class="flat btnmr">
                      Save
                    </button>
                    <button
                      type="button"
                      pButton
                      (click)="cancelConciergeInfo()"
                      class="ui-button-secondary flat">
                      Cancel
                    </button>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}

@if (showEngagements) {
  <div id="tblDiv">
    <div class="ui-g card">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="fundstatus">
          <div class="sbhd">Fund Status</div>
          <div class="ui-g">
            <div class="ui-g-12 ui-md-3 ui-lg-3 box bdrright">
              Requested Amount<br />
              @if (isC3CustomerBool === false) {
                <span class="clrblue">{{ requestedAmount | currency }}</span>
              }
              @if (isC3CustomerBool === true) {
                <span class="clrblue">$0</span>
              }
            </div>
            <div class="ui-g-12 ui-md-3 ui-lg-3 box bdrright">
              Requested Amount At Risk<br />
              @if (isC3CustomerBool === false) {
                <span class="clrorange">{{
                  eligibleAmountAtRisk | currency
                }}</span>
              }
              @if (isC3CustomerBool === true) {
                <span class="clrorange">$0</span>
              }
            </div>
            <div class="ui-g-12 ui-md-3 ui-lg-3 box bdrright">
              Approved Amount<br />
              @if (isC3CustomerBool === false) {
                <span class="clrblue">{{ approvedAmount | currency }}</span>
              }
              @if (isC3CustomerBool === true) {
                <span class="clrblue">$0</span>
              }
            </div>
            <div class="ui-g-12 ui-md-3 ui-lg-3 box">
              Approved Amount At Risk<br />
              @if (isC3CustomerBool === false) {
                <span class="clrorange">{{
                  approvedAmountAtRisk | currency
                }}</span>
              }
              @if (isC3CustomerBool === true) {
                <span class="clrorange">$0</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ui-g card">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="engactivity">
          <div class="sbhd">Engagement Activity</div>
          <table>
            <tr>
              <td
                class="engtdpanel"
                *ngFor="let eas of engagementActivityStatus; let i = index">
                {{ eas.status }}<br /><span>{{ eas.noOfEngagements }}</span>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="ui-g card">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="engactivitygeography">
          <div class="sbhd">
            Engagement Activity by Geography (Approved Engagements)
          </div>

          <p-table
            #ag
            [columns]="engcols"
            [scrollable]="true"
            [style]="{ width: '100%' }"
            [value]="engActivitybyCountry"
            selectionMode="single"
            [loadingIcon]="loadingIcon"
            [showLoader]="true"
            [(selection)]="selectedItem"
            dataKey="m365eventId"
            [paginator]="true"
            [rows]="dataViewRecsPerPage2"
            [pageLinks]="pageLinksPerPage"
            paginatorPosition="top"
            (onPage)="pageChangeEngGeography($event)"
            (onFilter)="applyFilterEngGeography($event)"
            exportFilename="EngagementRecords">
            <ng-template pTemplate="caption">
              <div style="text-align: left">
                <input
                  type="text"
                  pInputText
                  size="30"
                  placeholder="Search"
                  (input)="
                    ag.filterGlobal($any($event.target).value, 'contains')
                  "
                  style="width: auto"
                  [value]="
                    ag.filters['global'] ? $any(ag.filters['global']).value : ''
                  " />
                <i class="fa fa-search ml-2"></i>
                <span class="pageInfo visiblelg resettble">{{
                  currentPageInfoEngGeography
                }}</span>
                <span style="float: right"
                  ><a
                    (click)="resetEngGeography()"
                    (keydown.enter)="resetEngGeography()"
                    tabindex="0"
                    ><span class="fa fa-repeat"></span> Reset table</a
                  ></span
                >
              </div>
            </ng-template>
            <ng-template #header>
              <tr>
                <th [pSortableColumn]="'partnerOneSubID'" class="colmedium">
                  Partner One SubID<p-sortIcon
                    [field]="'partnerOneSubID'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'mpniDlist'" class="colmedium">
                  PartnerID List<p-sortIcon [field]="'mpniDlist'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'c3Engagement'" class="colmedium">
                  SMCEngagement<p-sortIcon
                    [field]="'c3Engagement'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'country'" class="colmedium">
                  Customer Country<p-sortIcon [field]="'country'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'noOFEngagements'" class="colmedium">
                  No Of Engagements<p-sortIcon
                    [field]="'noOFEngagements'"></p-sortIcon>
                </th>
              </tr>
              <tr></tr>
              <tr>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      ag.filter(
                        $any($event.target).value,
                        'partnerOneSubID',
                        'contains'
                      )
                    "
                    [value]="
                      ag.filters['partnerOneSubID']
                        ? $any(ag.filters['partnerOneSubID']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      ag.filter(
                        $any($event.target).value,
                        'mpniDlist',
                        'contains'
                      )
                    "
                    [value]="
                      ag.filters['mpniDlist']
                        ? $any(ag.filters['mpniDlist']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      ag.filter(
                        $any($event.target).value,
                        'c3Engagement',
                        'contains'
                      )
                    "
                    [value]="
                      ag.filters['c3Engagement']
                        ? $any(ag.filters['c3Engagement']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      ag.filter(
                        $any($event.target).value,
                        'country',
                        'contains'
                      )
                    "
                    [value]="
                      ag.filters['country']
                        ? $any(ag.filters['country']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      ag.filter(
                        $any($event.target).value,
                        'noOFEngagements',
                        'contains'
                      )
                    "
                    [value]="
                      ag.filters['noOfEngagements']
                        ? $any(ag.filters['noOfEngagements']).value
                        : ''
                    " />
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-rowData let-columns="columns">
              <tr>
                <td class="colmedium">{{ rowData.partnerOneSubID }}</td>
                <td class="colmedium">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.mpniDlist }}"
                    >{{ rowData.mpniDlist }}</span
                  >
                </td>
                <td class="colmedium">{{ rowData.c3Engagement }}</td>
                <td class="colmedium">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.country }}"
                    >{{ rowData.country }}</span
                  >
                </td>
                <td class="colmedium">{{ rowData.noOFEngagements }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              {{ emptyRecordMsg }}
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="ui-g card">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <div class="engactivitygeography">
          <div class="sbhd">
            Engagement Activity by Geography (Eligible Engagements)
          </div>

          <p-table
            #age
            [columns]="engcols"
            [scrollable]="true"
            [style]="{ width: '100%' }"
            [value]="engActivitybyCountryEligible"
            selectionMode="single"
            [loadingIcon]="loadingIcon"
            [showLoader]="true"
            [(selection)]="selectedItem"
            dataKey="m365eventId"
            [paginator]="true"
            [rows]="dataViewRecsPerPage2"
            [pageLinks]="pageLinksPerPage"
            paginatorPosition="top"
            (onPage)="pageChangeEngGeographyEligible($event)"
            (onFilter)="applyFilterEngGeographyEligible($event)"
            exportFilename="EngagementRecords">
            <ng-template pTemplate="caption">
              <div style="text-align: left">
                <input
                  type="text"
                  pInputText
                  size="30"
                  placeholder="Search"
                  (input)="
                    age.filterGlobal($any($event.target).value, 'contains')
                  "
                  style="width: auto"
                  [value]="
                    age.filters['global']
                      ? $any(age.filters['global']).value
                      : ''
                  " />
                <i class="fa fa-search ml-2"></i>
                <span class="pageInfo visiblelg resettble">{{
                  currentPageInfoEngGeographyEligible
                }}</span>
                <span style="float: right"
                  ><a
                    (click)="resetEngGeographyEligible()"
                    (keydown.enter)="resetEngGeographyEligible()"
                    tabindex="0"
                    ><span class="fa fa-repeat"></span> Reset table</a
                  ></span
                >
              </div>
            </ng-template>
            <ng-template #header>
              <tr>
                <th [pSortableColumn]="'partnerOneSubID'" class="colmedium">
                  Partner One SubID<p-sortIcon
                    [field]="'partnerOneSubID'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'mpniDlist'" class="colmedium">
                  PartnerID List<p-sortIcon [field]="'mpniDlist'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'c3Engagement'" class="colmedium">
                  SMCEngagement<p-sortIcon
                    [field]="'c3Engagement'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'country'" class="colmedium">
                  Customer Country<p-sortIcon [field]="'country'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'noOFEngagements'" class="colmedium">
                  No Of Engagements<p-sortIcon
                    [field]="'noOFEngagements'"></p-sortIcon>
                </th>
              </tr>
              <tr></tr>
              <tr>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    (input)="
                      age.filter(
                        $any($event.target).value,
                        'partnerOneSubID',
                        'contains'
                      )
                    "
                    [value]="
                      age.filters['partnerOneSubID']
                        ? $any(age.filters['partnerOneSubID']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      age.filter(
                        $any($event.target).value,
                        'mpniDlist',
                        'contains'
                      )
                    "
                    [value]="
                      age.filters['mpniDlist']
                        ? $any(age.filters['mpniDlist']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      age.filter(
                        $any($event.target).value,
                        'c3Engagement',
                        'contains'
                      )
                    "
                    [value]="
                      age.filters['c3Engagement']
                        ? $any(age.filters['c3Engagement']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      age.filter(
                        $any($event.target).value,
                        'country',
                        'contains'
                      )
                    "
                    [value]="
                      age.filters['country']
                        ? $any(age.filters['country']).value
                        : ''
                    " />
                </th>
                <th class="dashtable colmedium">
                  <input
                    pInputText
                    type="text"
                    type="text"
                    (input)="
                      age.filter(
                        $any($event.target).value,
                        'noOFEngagements',
                        'contains'
                      )
                    "
                    [value]="
                      age.filters['noOfEngagements']
                        ? $any(age.filters['noOfEngagements']).value
                        : ''
                    " />
                </th>
              </tr>
            </ng-template>
            <ng-template #body let-rowData let-columns="columns">
              <tr>
                <td class="colmedium">{{ rowData.partnerOneSubID }}</td>
                <td class="colmedium">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.mpniDlist }}"
                    >{{ rowData.mpniDlist }}</span
                  >
                </td>
                <td class="colmedium">{{ rowData.c3Engagement }}</td>
                <td class="colmedium">
                  <span
                    tooltipPosition="top"
                    pTooltip="{{ rowData.country }}"
                    >{{ rowData.country }}</span
                  >
                </td>
                <td class="colmedium">{{ rowData.noOFEngagements }}</td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              {{ emptyRecordMsg }}
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>
    <div class="ui-g card brdtable">
      <div class="ui-g-12 ui-md-12 ui-lg-12">
        <p-tabs scrollable value="0">
          <p-tablist>
            <p-tab value="0">Eligible Nominations</p-tab>
            <p-tab value="1">Approved Nominations</p-tab>
            <p-tab value="2">All Nominations</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="0">
              <p-table
                #eg
                [columns]="cols"
                [scrollable]="true"
                [style]="{ width: '100%' }"
                [value]="eligibleEng"
                selectionMode="single"
                [loadingIcon]="loadingIcon"
                [showLoader]="true"
                [(selection)]="selectedItem"
                dataKey="m365eventId"
                [paginator]="true"
                [rows]="dataViewRecsPerPage"
                [pageLinks]="pageLinksPerPage"
                paginatorPosition="top"
                (onPage)="pageChangeEligible($event)"
                (onFilter)="applyFilterEligible($event)"
                exportFilename="EngagementRecords">
                <ng-template pTemplate="caption">
                  <div style="text-align: left">
                    <input
                      type="text"
                      pInputText
                      size="30"
                      placeholder="Search"
                      (input)="
                        eg.filterGlobal($any($event.target).value, 'contains')
                      "
                      style="width: auto"
                      [value]="
                        eg.filters['global']
                          ? $any(eg.filters['global']).value
                          : ''
                      " />
                    <i class="fa fa-search ml-2"></i>
                    <span class="pageInfo visiblelg resettble">{{
                      currentPageInfoEligible
                    }}</span>
                    <span style="float: right"
                      ><a
                        (click)="resetEligibleList()"
                        (keydown.enter)="resetEligibleList()"
                        tabindex="0"
                        ><span class="fa fa-repeat"></span> Reset table</a
                      ></span
                    >
                  </div>
                </ng-template>
                <ng-template #header>
                  <tr>
                    <th [pSortableColumn]="'engagementId'" class="colmedium">
                      Engagement ID<p-sortIcon
                        [field]="'engagementId'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'engagementSubType'"
                      class="colmedium">
                      Engagement Type<p-sortIcon
                        [field]="'engagementSubType'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'customerName'" class="colmedium">
                      Eligible Customers<p-sortIcon
                        [field]="'customerName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'c3Engagement'" class="colmedium">
                      SMCEngagement<p-sortIcon
                        [field]="'c3Engagement'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'customerCountry'" class="colmedium">
                      Customer Country<p-sortIcon
                        [field]="'customerCountry'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'daysLeft'" class="colsmall">
                      Days Left<p-sortIcon [field]="'daysLeft'"></p-sortIcon>
                    </th>
                  </tr>
                  <tr></tr>
                  <tr>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          eg.filter(
                            $any($event.target).value,
                            'engagementId',
                            'contains'
                          )
                        "
                        [value]="
                          eg.filters['engagementId']
                            ? $any(eg.filters['engagementId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          eg.filter(
                            $any($event.target).value,
                            'engagementSubType',
                            'contains'
                          )
                        "
                        [value]="
                          eg.filters['engagementSubType']
                            ? $any(eg.filters['engagementSubType']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          eg.filter(
                            $any($event.target).value,
                            'customerName',
                            'contains'
                          )
                        "
                        [value]="
                          eg.filters['customerName']
                            ? $any(eg.filters['customerName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          eg.filter(
                            $any($event.target).value,
                            'c3Engagement',
                            'contains'
                          )
                        "
                        [value]="
                          eg.filters['c3Engagement']
                            ? $any(eg.filters['c3Engagement']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          eg.filter(
                            $any($event.target).value,
                            'customerCountry',
                            'contains'
                          )
                        "
                        [value]="
                          eg.filters['customerCountry']
                            ? $any(eg.filters['customerCountry']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          eg.filter(
                            $any($event.target).value,
                            'daysLeft',
                            'contains'
                          )
                        "
                        [value]="
                          eg.filters['daysLeft']
                            ? $any(eg.filters['daysLeft']).value
                            : ''
                        " />
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-rowData let-columns="columns">
                  <tr
                    (dblclick)="
                      editRequestDetails($event, rowData.engagementId)
                    ">
                    <td class="colmedium">
                      <a
                        (click)="
                          editRequestDetails($event, rowData.engagementId)
                        "
                        class="editlink"
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementId }}"
                        (keypress)="
                          editRequestDetails($event, rowData.engagementId)
                        "
                        tabindex="0"
                        >{{ rowData.engagementId }}</a
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementSubType }}"
                        >{{ rowData.engagementSubType }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.customerName }}"
                        >{{ rowData.customerName }}</span
                      >
                    </td>
                    <td class="colmedium">{{ rowData.c3Engagement }}</td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.customerCountry }}"
                        >{{ rowData.customerCountry }}</span
                      >
                    </td>
                    <td class="colsmall">{{ rowData.daysLeft }}</td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  {{ emptyRecordMsg }}
                </ng-template>
              </p-table>
            </p-tabpanel>
            <p-tabpanel value="1">
              <p-table
                #ap
                [columns]="cols"
                [scrollable]="true"
                [style]="{ width: '100%' }"
                [value]="approvedEng"
                selectionMode="single"
                [loadingIcon]="loadingIcon"
                [showLoader]="true"
                [(selection)]="selectedItem"
                dataKey="m365eventId"
                [paginator]="true"
                [rows]="dataViewRecsPerPage"
                [pageLinks]="pageLinksPerPage"
                paginatorPosition="top"
                (onPage)="pageChangeApproved($event)"
                (onFilter)="applyFilterApproved($event)"
                exportFilename="EngagementRecords">
                <ng-template pTemplate="caption">
                  <div style="text-align: left">
                    <input
                      type="text"
                      pInputText
                      size="30"
                      placeholder="Search"
                      (input)="
                        ap.filterGlobal($any($event.target).value, 'contains')
                      "
                      style="width: auto"
                      [value]="
                        ap.filters['global']
                          ? $any(ap.filters['global']).value
                          : ''
                      " />
                    <i class="fa fa-search ml-2"></i>
                    <span class="pageInfo visiblelg resettble">{{
                      currentPageInfoApproved
                    }}</span>
                    <span style="float: right"
                      ><a
                        (click)="resetApprovedList()"
                        (keydown.enter)="resetApprovedList()"
                        tabindex="0"
                        ><span class="fa fa-repeat"></span> Reset table</a
                      ></span
                    >
                  </div>
                </ng-template>
                <ng-template #header>
                  <tr>
                    <th [pSortableColumn]="'engagementId'" class="colmedium">
                      Engagement ID<p-sortIcon
                        [field]="'engagementId'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'engagementSubType'"
                      class="colmedium">
                      Engagement Type<p-sortIcon
                        [field]="'engagementSubType'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'customerName'" class="colmedium">
                      Customer Name<p-sortIcon
                        [field]="'customerName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'c3Engagement'" class="colmedium">
                      SMCEngagement<p-sortIcon
                        [field]="'c3Engagement'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'customerCountry'" class="colmedium">
                      Customer Country<p-sortIcon
                        [field]="'customerCountry'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'daysLeft'" class="colsmall">
                      Days Left<p-sortIcon [field]="'daysLeft'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'poeStatus'" class="colmedium">
                      POE Status<p-sortIcon [field]="'poeStatus'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'workshopScheduleDate'"
                      class="colmedium">
                      Workshop Date<p-sortIcon
                        [field]="'workshopScheduleDate'"></p-sortIcon>
                    </th>
                  </tr>
                  <tr></tr>
                  <tr>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          ap.filter(
                            $any($event.target).value,
                            'engagementId',
                            'contains'
                          )
                        "
                        [value]="
                          ap.filters['engagementId']
                            ? $any(ap.filters['engagementId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          ap.filter(
                            $any($event.target).value,
                            'engagementSubType',
                            'contains'
                          )
                        "
                        [value]="
                          ap.filters['engagementSubType']
                            ? $any(ap.filters['engagementSubType']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          ap.filter(
                            $any($event.target).value,
                            'customerName',
                            'contains'
                          )
                        "
                        [value]="
                          ap.filters['customerName']
                            ? $any(ap.filters['customerName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          ap.filter(
                            $any($event.target).value,
                            'c3Engagement',
                            'contains'
                          )
                        "
                        [value]="
                          ap.filters['c3Engagement']
                            ? $any(ap.filters['c3Engagement']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          ap.filter(
                            $any($event.target).value,
                            'customerCountry',
                            'contains'
                          )
                        "
                        [value]="
                          ap.filters['customerCountry']
                            ? $any(ap.filters['customerCountry']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          ap.filter(
                            $any($event.target).value,
                            'daysLeft',
                            'contains'
                          )
                        "
                        [value]="
                          ap.filters['daysLeft']
                            ? $any(ap.filters['daysLeft']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <p-multiSelect
                        #aptak
                        appendTo="body"
                        [options]="poeStatusAppDrpdwn"
                        placeholder="POE Status"
                        (onChange)="
                          ap.filter($event.value, 'poeStatus', 'in')
                        "></p-multiSelect>
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          ap.filter(
                            $any($event.target).value,
                            'workshopScheduleDate',
                            'contains'
                          )
                        "
                        [value]="
                          ap.filters['workshopScheduleDate']
                            ? $any(ap.filters['workshopScheduleDate']).value
                            : ''
                        " />
                    </th>
                  </tr>
                </ng-template>
                <ng-template #body let-rowData let-columns="columns">
                  <tr
                    (dblclick)="
                      editRequestDetails($event, rowData.engagementId)
                    ">
                    <td class="colmedium">
                      <a
                        (click)="
                          editRequestDetails($event, rowData.engagementId)
                        "
                        class="editlink"
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementId }}"
                        (keypress)="
                          editRequestDetails($event, rowData.engagementId)
                        "
                        tabindex="0"
                        >{{ rowData.engagementId }}</a
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementSubType }}"
                        >{{ rowData.engagementSubType }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.customerName }}"
                        >{{ rowData.customerName }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.c3Engagement }}"
                        >{{ rowData.c3Engagement }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.customerCountry }}"
                        >{{ rowData.customerCountry }}</span
                      >
                    </td>
                    <td class="colsmall">{{ rowData.daysLeft }}</td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.poeStatus }}"
                        >{{ rowData.poeStatus }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{
                          rowData.workshopScheduleDate | date: 'yyyy-MM-dd'
                        }}"
                        >{{
                          rowData.workshopScheduleDate | date: 'yyyy-MM-dd'
                        }}</span
                      >
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  {{ emptyRecordMsg }}
                </ng-template>
              </p-table>
            </p-tabpanel>
            <p-tabpanel value="2">
              <p-table
                #dt
                [columns]="cols"
                [scrollable]="true"
                [style]="{ width: '100%' }"
                [value]="engagements"
                selectionMode="single"
                [loadingIcon]="loadingIcon"
                [showLoader]="true"
                [(selection)]="selectedItem"
                dataKey="m365eventId"
                [paginator]="true"
                [rows]="dataViewRecsPerPage"
                [pageLinks]="pageLinksPerPage"
                paginatorPosition="both"
                (onPage)="pageChange($event)"
                (onFilter)="applyFilter($event)"
                exportFilename="EngagementRecords">
                <ng-template pTemplate="caption">
                  <div style="text-align: left">
                    <input
                      type="text"
                      pInputText
                      size="30"
                      placeholder="Search"
                      (input)="
                        dt.filterGlobal($any($event.target).value, 'contains')
                      "
                      style="width: auto"
                      [value]="
                        dt.filters['global']
                          ? $any(dt.filters['global']).value
                          : ''
                      " />
                    <i class="fa fa-search ml-2"></i>
                    <span class="pageInfo visiblelg resettble">{{
                      currentPageInfo
                    }}</span>
                    <span style="float: right"
                      ><a
                        (click)="resetNominationsList()"
                        (keydown.enter)="resetNominationsList()"
                        tabindex="0"
                        ><span class="fa fa-repeat"></span> Reset table</a
                      ></span
                    >
                  </div>
                </ng-template>

                <ng-template #header>
                  <tr>
                    <th [pSortableColumn]="'engagementId'" class="colmedium">
                      Engagement ID<p-sortIcon
                        [field]="'engagementId'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'engagementType'" class="colmedium">
                      Engagement Name<p-sortIcon
                        [field]="'engagementType'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'engagementSubType'"
                      class="colmedium">
                      Engagement Type<p-sortIcon
                        [field]="'engagementSubType'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'customerName'" class="colmedium">
                      Customer Name<p-sortIcon
                        [field]="'customerName'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'engagementStatus'" class="colsmall">
                      Status<p-sortIcon
                        [field]="'engagementStatus'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'c3Engagement'" class="colmedium">
                      SMCEngagement<p-sortIcon
                        [field]="'c3Engagement'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'customerCountry'" class="colmedium">
                      Customer Country<p-sortIcon
                        [field]="'customerCountry'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'amount'" class="colmedium">
                      Funding Amount<p-sortIcon [field]="'amount'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'expirationDate'" class="colmedium">
                      Expiration Date<p-sortIcon
                        [field]="'expirationDate'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'partnerContact'" class="colmedium">
                      Nominated By<p-sortIcon
                        [field]="'partnerContact'"></p-sortIcon>
                    </th>
                    <th [pSortableColumn]="'poeStatus'" class="colmedium">
                      POE Status<p-sortIcon [field]="'poeStatus'"></p-sortIcon>
                    </th>
                    <th
                      [pSortableColumn]="'workshopScheduleDate'"
                      class="colmedium">
                      Workshop Date<p-sortIcon
                        [field]="'workshopScheduleDate'"></p-sortIcon>
                    </th>
                  </tr>
                  <tr>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'engagementId',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['engagementId']
                            ? $any(dt.filters['engagementId']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable">
                      <p-multiSelect
                        #tak
                        [options]="fengagementTypeDrpdwn"
                        appendTo="body"
                        placeholder="Engagement Type"
                        (onChange)="
                          dt.filter($event.value, 'engagementType', 'in')
                        ">
                      </p-multiSelect>
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'engagementSubType',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['engagementSubType']
                            ? $any(dt.filters['engagementSubType']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'customerName',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['customerName']
                            ? $any(dt.filters['customerName']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'engagementStatus',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['engagementStatus']
                            ? $any(dt.filters['engagementStatus']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'c3Engagement',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['c3Engagement']
                            ? $any(dt.filters['c3Engagement']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colmedium">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'customerCountry',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['customerCountry']
                            ? $any(dt.filters['customerCountry']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable">
                      <input
                        pInputText
                        type="text"
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'amount',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['amount']
                            ? $any(dt.filters['amount']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'expirationDate',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['expirationDate']
                            ? $any(dt.filters['expirationDate']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'partnerContact',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['partnerContact']
                            ? $any(dt.filters['partnerContact']).value
                            : ''
                        " />
                    </th>
                    <th class="dashtable colsmall">
                      <p-multiSelect
                        #tak
                        appendTo="body"
                        [options]="poeStatusDrpdwn"
                        placeholder="POE Status"
                        (onChange)="
                          dt.filter($event.value, 'poeStatus', 'in')
                        "></p-multiSelect>
                    </th>
                    <th class="dashtable colsmall">
                      <input
                        pInputText
                        type="text"
                        (input)="
                          dt.filter(
                            $any($event.target).value,
                            'workshopScheduleDate',
                            'contains'
                          )
                        "
                        [value]="
                          dt.filters['workshopScheduleDate']
                            ? $any(dt.filters['workshopScheduleDate']).value
                            : ''
                        " />
                    </th>
                  </tr>
                </ng-template>

                <ng-template #body let-rowData let-columns="columns">
                  <tr
                    (dblclick)="
                      editRequestDetails($event, rowData.engagementId)
                    ">
                    <td class="colmedium">
                      <a
                        (click)="
                          editRequestDetails($event, rowData.engagementId)
                        "
                        class="editlink"
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementId }}"
                        (keypress)="
                          editRequestDetails($event, rowData.engagementId)
                        "
                        tabindex="0"
                        >{{ rowData.engagementId }}</a
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementType }}"
                        >{{ rowData.engagementType }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementSubType }}"
                        >{{ rowData.engagementSubType }}</span
                      >
                    </td>

                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.customerName }}"
                        >{{ rowData.customerName }}</span
                      >
                    </td>

                    <td class="colsmall">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.engagementStatus }}"
                        >{{ rowData.engagementStatus }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.c3Engagement }}"
                        >{{ rowData.c3Engagement }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.customerCountry }}"
                        >{{ rowData.customerCountry }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.amount | currency }}"
                        >{{ rowData.amount | currency }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{
                          rowData.expirationDate | date: 'yyyy-MM-dd'
                        }}"
                        >{{ rowData.expirationDate | date: 'yyyy-MM-dd' }}</span
                      >
                    </td>

                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.partnerContact }}"
                        >{{ rowData.partnerContact }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{ rowData.poeStatus }}"
                        >{{ rowData.poeStatus }}</span
                      >
                    </td>
                    <td class="colmedium">
                      <span
                        tooltipPosition="top"
                        pTooltip="{{
                          rowData.workshopScheduleDate | date: 'yyyy-MM-dd'
                        }}"
                        >{{
                          rowData.workshopScheduleDate | date: 'yyyy-MM-dd'
                        }}</span
                      >
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  {{ emptyRecordMsg }}
                </ng-template>
              </p-table>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  </div>
}

@if (loadEditComponent) {
  <p-dialog
    id="engagementEdit"
    [closable]="true"
    [draggable]="false"
    [resizable]="true"
    [(visible)]="editNav"
    modal="modal"
    showEffect="fade"
    (onHide)="onCloseEditModal()"
    [ngClass]="showFullscreen ? 'fullscreenView' : 'notFullScreen'">
    @if (loadEditComponent) {
      <app-edit
        [engagementEditInput]="engagementEditInput"
        #editNavChild
        (refreshPartnerInput)="refresh()"
        (showFullscreen)="onShowFullScreenChanged($event)"
        (closeEditSidebar)="editNav = $event"></app-edit>
    }
  </p-dialog>
}
